

/**
 * Are we on the dev environment
 *
 * @returns
 */
export function isDev(): boolean {
    // we might not have window.xaStudioConfig so we also look to see if we are localhost
    if (!window.xaStudioConfig) {
        // it can either be localhost or subdomain qa-go
        return window.location.hostname === "localhost" || window.location.hostname.includes("qa-go");
    } else {
        return window.xaStudioConfig?.environment === "development";
    }
}

export function isProd(): boolean {
    if (!window.xaStudioConfig) {
        return window.location.hostname !== "localhost";
    } else {
        return window.xaStudioConfig?.environment === "production";
    }
}